export const amortizationPlanCommand = {
  createPlan: 'createPlan',
  createPaymentNotices: 'createPaymentNotices',
};
